import React, { useCallback } from "react";

import { faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import styles from "./TextField.module.css";

type Props = React.HTMLProps<HTMLInputElement> &
	React.InputHTMLAttributes<HTMLInputElement> & {
		value: string;
		setValue?: (val: string) => void;
		onClear?: () => void;
		withCross?: boolean;
		error?: boolean;
		borderless?: boolean;
		wrapperClassname?: string;
		icon?: React.ReactNode;
	};

const TextField = React.forwardRef<HTMLInputElement, Props>(
	(
		{
			className,
			value,
			setValue,
			onChange,
			onClear,
			withCross,
			wrapperClassname,
			error,
			borderless,
			icon,
			...rest
		}: Props,
		ref,
	) => {
		const changeField = useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				setValue?.(e.target.value);
				onChange?.(e);
			},
			[setValue, onChange],
		);

		const displayCross = withCross && !!value;
		const clearClicked = useCallback(() => {
			setValue?.("");
			onClear?.();
		}, [setValue, onClear]);

		return (
			<div className={cx(styles.inputWrapper, wrapperClassname)}>
				{icon && (
					<div className={cx(styles.icon, styles.left)}>
						<div className={styles.iconWrapper}>{icon}</div>
					</div>
				)}
				<input
					{...rest}
					value={value}
					onChange={changeField}
					className={cx(styles.input, className, {
						[styles.withCross]: displayCross,
						[styles.withIcon]: !!icon,
						[styles.error]: error,
						[styles.borderless]: borderless,
					})}
					ref={ref}
				/>
				{displayCross && (
					<div className={cx(styles.icon, styles.right)} onClick={clearClicked}>
						<div className={styles.iconWrapper}>
							<FontAwesomeIcon icon={faTimes} />
						</div>
					</div>
				)}
			</div>
		);
	},
);

TextField.displayName = "TextField";

export default TextField;
